/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/tabs/tab/tabhead/tabhead_styles';



/* ========== ~~~~~~~~~~ TAB HEAD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class TabHead extends Component {
	handleTabSelect = (e) => this.props.setActiveTab(this.props.id); // pass back ID to parent tabs component to set state there
	render() {
	    return(
	    	<div id={this.props.id} className={`tabhead ${this.props.classes.tabhead} ${this.props.isActive ? 'on' : 'off'}`} onClick={this.handleTabSelect}>
	    		<div className={`tabtitle`}>{this.props.title}</div>
	    		<div className={`tabdivider`}></div>
	        </div>
	    );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(TabHead);
